import { base64ToFile } from 'common/helpers/getBase64.helper';
import fileService from 'common/services/file-service/file.service';
import { UploadFileTypes } from 'common/services/file-service/file.service.types';
import guestService from 'common/services/guest-service/guest.service';
import { IAddIdDocument } from 'common/services/guest-service/guest.service.types';
import { notification } from 'common/utils/notification';

export type CapturedIdDocument = Omit<IAddIdDocument, 'imageUrl'> & { imageBase64: string };
export type IdDocumentNames = { firstName?: string | null; lastName?: string | null };
type DocumentSummary = IdDocumentNames & { imageUrl?: string | null; type?: IAddIdDocument['type'] | null };

export const getIdDocumentName = (document?: IdDocumentNames | null) =>
  document?.firstName && document.lastName ? `${document.firstName} ${document.lastName}`.trim() : null;

export const getIdDocumentAdmitFields = (document?: DocumentSummary | null) => ({
  idDocumentUrl: document?.imageUrl || null,
  idDocumentType: document?.type || null,
  verifiedName: getIdDocumentName(document),
});

export const uploadIdDocumentImage = async (document: CapturedIdDocument, snapshotNames?: IdDocumentNames) => {
  const names = document.type === 'snapshot' && snapshotNames ? snapshotNames : document;
  const fileName = `${names.firstName}_${names.lastName}_${document.type}.jpg`;
  const file = base64ToFile(document.imageBase64, fileName);

  if (file.size === 0) {
    notification.warning({ message: `File = ${fileName}, length = 0`, duration: 10 });
    return null;
  }

  const result = await fileService.uploadPhoto(file, UploadFileTypes.IdDocument);
  return result.absoluteUri;
};

export const saveGuestIdDocument = async (document: CapturedIdDocument, residentId: number, addressId: number, guestId: number) => {
  const imageUrl = (await uploadIdDocumentImage(document)) ?? '';

  const requestData: IAddIdDocument = {
    type: document.type,
    imageUrl,
    firstName: document.firstName,
    lastName: document.lastName,
    gender: document.gender,
    dateOfBirth: document.dateOfBirth,
    nationality: document.nationality,
    address: document.address,
    issuingCountry: document.issuingCountry,
    issuingCountryIso: document.issuingCountryIso,
    number: document.number,
    additionalNumber: document.additionalNumber,
    expiredAt: document.expiredAt,
    issuedAt: document.issuedAt,
  };
  return guestService.addIdDocument(residentId, addressId, guestId, requestData);
};

export const prepareVisitorIdDocument = async (document: CapturedIdDocument | null | undefined, snapshotNames: IdDocumentNames) => {
  if (!document) {
    return getIdDocumentAdmitFields(null);
  }
  const imageUrl = await uploadIdDocumentImage(document, snapshotNames);

  if (imageUrl === null) {
    return getIdDocumentAdmitFields(null);
  }

  return getIdDocumentAdmitFields({ ...document, imageUrl });
};
